import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import {
  ErrorDetails,
  VehicleGridResponse
} from "app/services/authentication/connection/interfaces/apiInterfaces";
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";

export class FindVehiclesByDomainContains extends IRequestCommand<
  IFindVehiclesByDomainContainsClientsResponse,
  ErrorDetails,
  IFindVehiclesByDomainContainsClientsCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierId}/vehicles?domain={domain}';
  override _needAuthenticate = true;
  public override setParameters(
    parameters: IFindVehiclesByDomainContainsClientsCommandParameters
  ) {
    this._commandUrl = this._commandUrl.replace(
      '{domain}',
      parameters.terms.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId.toString()
    );
  }
}

// tslint:disable-next-line:no-empty-interface
export interface IFindVehiclesByDomainContainsClientsCommandParameters
  extends ICommandParameters {
  terms: string;
  carrierId: string;
}

export interface IFindVehiclesByDomainContainsClientsResponse
  extends VehicleGridResponse,
    ICommandResponse {}
